"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualProductPaymentChoiceWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
require("react-datepicker/src/stylesheets/datepicker.scss");
var journey_model_1 = require("@athena-portal/journey-model");
var journey_services_1 = require("@ferry/journey-services");
var AnnualMotorMtaPremiumWordingGenerator_1 = require("../../../helpers/annual/motor/AnnualMotorMtaPremiumWordingGenerator");
var core_1 = require("@athena-portal/core");
var components_1 = require("@athena-portal/components");
var commonFunctions_1 = require("../../../commonFunctions");
var AnnualProductPaymentChoiceWidget = /** @class */ (function (_super) {
    __extends(AnnualProductPaymentChoiceWidget, _super);
    function AnnualProductPaymentChoiceWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.handleOnChangeEvent = function (event) {
            if (event.target.value === "fullPrice") {
                _this.props.onStateChange("uistate.payFullPrice", true);
                _this.props.onStateChange("uistate.spreadPrice", false);
                _this.setState({ payFullPrice: true, spreadPrice: false });
            }
            else if (event.target.value === "spreadPrice") {
                _this.props.onStateChange("uistate.payFullPrice", false);
                _this.props.onStateChange("uistate.spreadPrice", true);
                _this.setState({ payFullPrice: false, spreadPrice: true });
            }
            // Re-generate MTA success modal body wording
            // due to choice between immediate payment and spreading additional premium across existing monthly payments
            var mtaPremiumWording = AnnualMotorMtaPremiumWordingGenerator_1.AnnualMotorMtaPremiumWordingGenerator.generateMtaPremiumWording(_this.props.interaction, _this.state.previousPolicyInteraction);
            if (mtaPremiumWording.isGenericModalBodyWording) {
                window.sessionStorage.setItem("mtaHeadsUpMessageText", mtaPremiumWording.successModalBodyWording);
            }
            else {
                window.sessionStorage.setItem("mtaSuccessMessageText", mtaPremiumWording.successModalBodyWording);
            }
        };
        _this.navigateNext = function () {
            _this.props.engine.navigate(_this.getSetting("paymentPageId"));
        };
        _this.navigateBack = function () {
            if (_this.getSetting("previousPageId")) {
                _this.props.engine.navigate(_this.getSetting("previousPageId"));
            }
        };
        _this.getAmountToPay = function () {
            return (_this.props.interaction.factors.amountToPay)
                ? _this.props.interaction.factors.amountToPay
                : _this.props.interaction.paymentDetails.instalmentPlan.deposit;
        };
        _this.state = {
            payFullPrice: Boolean(_this.props.interaction.uistate.payFullPrice),
            spreadPrice: Boolean(_this.props.interaction.uistate.spreadPrice),
            isVulnerableCustomer: false,
            isMTC: false,
            dataLoaded: false,
            previousPolicyInteraction: null
        };
        return _this;
    }
    AnnualProductPaymentChoiceWidget_1 = AnnualProductPaymentChoiceWidget;
    AnnualProductPaymentChoiceWidget.prototype.componentDidMount = function () {
        var _this = this;
        var interaction = this.props.interaction;
        var isVulnerableCustomer = interaction.uistate.vulnerableCustomer;
        var isMTC = interaction.process === "MTC";
        this.propositionEngine.fetchInteractionByEmailAndDob(journey_services_1.ProductsEnum.WOLF_MOTOR, interaction.uistate.relativeInteractionId, interaction.policyHolder.email, interaction.policyHolder.dateOfBirth).subscribe(function (previousPolicyInteraction) {
            _this.setState({
                previousPolicyInteraction: previousPolicyInteraction,
                dataLoaded: true,
            });
        });
        this.setState({
            isVulnerableCustomer: isVulnerableCustomer,
            isMTC: isMTC,
        });
    };
    AnnualProductPaymentChoiceWidget.prototype.render = function () {
        if (!this.state.dataLoaded) {
            return (0, jsx_runtime_1.jsx)(components_1.Overlay, { show: true });
        }
        var interaction = this.props.interaction;
        var instalmentPlan = interaction.paymentDetails.instalmentPlan;
        var isMonthlyPaymentsSpreadAvailable = instalmentPlan.instalments.length > 1 && instalmentPlan.totalAmount > 0;
        var _a = interaction.uistate, payFullPrice = _a.payFullPrice, spreadPrice = _a.spreadPrice;
        var spreadPriceValid = Boolean(spreadPrice) && isMonthlyPaymentsSpreadAvailable;
        var optionSelected = Boolean(payFullPrice) !== spreadPriceValid;
        var disabledClass = optionSelected ? "" : "btn-disabled";
        return ((0, jsx_runtime_1.jsxs)("div", { className: "w-100", children: [(0, jsx_runtime_1.jsx)("div", { className: "premium-info no-background-color", children: (0, jsx_runtime_1.jsxs)("div", { className: "payment-choice", children: [this.renderPayFullOption(interaction), isMonthlyPaymentsSpreadAvailable && this.renderMonthlyPaymentOption(interaction)] }) }), this.getSetting("paymentPageId") &&
                    (0, jsx_runtime_1.jsx)("button", { className: "mb-0 btn btn-primary btn-next ".concat(disabledClass), id: "".concat(this.props.question.name), onClick: this.navigateNext, children: "Next" }), this.getSetting("previousPageId") &&
                    (0, jsx_runtime_1.jsx)("button", { className: "btn btn-back", onClick: this.navigateBack, children: "Back" })] }));
    };
    AnnualProductPaymentChoiceWidget.prototype.renderPayFullOption = function (interaction) {
        var checked = this.state.payFullPrice;
        return ((0, jsx_runtime_1.jsx)("div", { className: "premium-checkbox cursor-pointer ".concat(checked ? "checked" : "not-checked"), children: (0, jsx_runtime_1.jsxs)("div", { className: "custom-radiobutton-container", children: [(0, jsx_runtime_1.jsx)("input", { id: "yearly", className: "custom-radiobutton", type: "radio", name: "payment", value: "fullPrice", checked: checked, onChange: this.handleOnChangeEvent }), (0, jsx_runtime_1.jsxs)("label", { className: "premium-description", htmlFor: "yearly", children: [(0, jsx_runtime_1.jsxs)("p", { className: "font-weight-semi-bold pt-3", children: ["Pay ", (0, commonFunctions_1.getAmountWithDecimalDigits)(this.getAmountToPay()), " now by card"] }), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("img", { className: "visa-icon-small ".concat(checked ? "checked" : ""), alt: "visa-icon", src: "".concat(checked ? "/img/visa-icon-white.svg" : "/img/visa-icon.svg") }), (0, jsx_runtime_1.jsx)("img", { className: "mastercard-icon-small ".concat(checked ? "checked" : ""), alt: "mastercard-icon", src: "/img/mastercard-icon.svg" })] })] })] }) }));
    };
    AnnualProductPaymentChoiceWidget.prototype.renderMonthlyPaymentOption = function (interaction) {
        var isChecked = this.state.spreadPrice;
        var _a = interaction.factors, upfrontPaymentAmount = _a.upfrontPaymentAmount, spreadIncludesInterest = _a.monthlyPaymentSpreadWithInterestAmount;
        var monthlyPaymentsSpread = this.getMonthlyPaymentsSpread(spreadIncludesInterest);
        var isDirectDebit = journey_services_1.productHelper.isDirectDebit(interaction);
        var disableUpfrontPayment = AnnualProductPaymentChoiceWidget_1.getDisableUpfrontPayment(isDirectDebit, upfrontPaymentAmount, interaction.factors.amountToPay);
        var showVulnerableText = this.state.isVulnerableCustomer && this.state.isMTC;
        return ((0, jsx_runtime_1.jsx)("div", { className: "premium-checkbox annual cursor-pointer ".concat(isChecked ? "checked" : "not-checked"), children: (0, jsx_runtime_1.jsxs)("div", { className: "custom-radiobutton-container", children: [(0, jsx_runtime_1.jsx)("input", { id: "monthly", className: "custom-radiobutton", type: "radio", name: "payment", value: "spreadPrice", checked: isChecked, onChange: this.handleOnChangeEvent }), (0, jsx_runtime_1.jsx)("label", { className: "premium-description", htmlFor: "monthly", children: (!this.state.isVulnerableCustomer && disableUpfrontPayment) || showVulnerableText ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("p", { className: "font-weight-semi-bold pt-3", children: "Monthly payments" }), (0, jsx_runtime_1.jsx)("p", { className: "pt-3", children: "Continue with your monthly payment plan" })] })) : ((0, jsx_runtime_1.jsxs)("p", { className: "font-weight-semi-bold pt-3", children: ["Pay ", (0, commonFunctions_1.getAmountWithDecimalDigits)(upfrontPaymentAmount), " now and continue to pay\u00A0", (0, commonFunctions_1.getAmountWithDecimalDigits)(monthlyPaymentsSpread), " ", spreadIncludesInterest && "(incl. interest)", " with your monthly payments"] })) })] }) }));
    };
    AnnualProductPaymentChoiceWidget.getDisableUpfrontPayment = function (isDirectDebit, upfrontPaymentAmount, additionalPremium) {
        return isDirectDebit ? upfrontPaymentAmount <= 0 : (upfrontPaymentAmount < journey_services_1.UPFRONT_PAYMENT_THRESHOLD || additionalPremium < journey_services_1.UPFRONT_PAYMENT_THRESHOLD);
    };
    AnnualProductPaymentChoiceWidget.prototype.getMonthlyPaymentsSpread = function (spreadIncludesInterest) {
        return spreadIncludesInterest
            ? this.props.interaction.factors.monthlyPaymentSpreadWithInterestAmount
            : this.props.interaction.factors.monthlyPaymentSpreadAmount;
    };
    var AnnualProductPaymentChoiceWidget_1;
    __decorate([
        (0, core_1.lazyInject)(journey_services_1.Types.FalconPropositionEngine),
        __metadata("design:type", Object)
    ], AnnualProductPaymentChoiceWidget.prototype, "propositionEngine", void 0);
    AnnualProductPaymentChoiceWidget = AnnualProductPaymentChoiceWidget_1 = __decorate([
        (0, journey_model_1.settings)([
            { name: "previousPageId", type: journey_model_1.TypeDescriptions.String },
            { name: "paymentPageId", type: journey_model_1.TypeDescriptions.String }
        ]),
        __metadata("design:paramtypes", [Object])
    ], AnnualProductPaymentChoiceWidget);
    return AnnualProductPaymentChoiceWidget;
}(plugin_journey_1.WidgetBase));
exports.AnnualProductPaymentChoiceWidget = AnnualProductPaymentChoiceWidget;
//# sourceMappingURL=AnnualProductPaymentChoiceWidget.js.map